import { isLoadingProjects } from 'owa-timestream-store';
import { DefaultBoardCreationState } from '../schema';
import getDefaultBoardCreationState from './getDefaultBoardCreationState';

/**
 * Checks to see if the default calendar board project is being created or loading.
 * @returns true if the default calendar board project is creating or loading, false otherwise.
 */
export default function isLoadingCalendarBoardProject(): boolean {
    const projectCreationState = getDefaultBoardCreationState();

    // if project is being created, show loading view
    if (projectCreationState === DefaultBoardCreationState.Creating) {
        return true;
    }

    return isLoadingProjects();
}
